import * as actionTypes from '../../constants/actionTypes';

import { CALL_PRIVATE_API } from '../../middleware/api';
import { dataSetSchema } from '../../schemas';
import { GET } from '../../constants/requestMethods';
import { loadPublicDataSets, loadPublicDataSetsSummay } from '../dataSetsPublic';

export const loadMyAvailableDataSets = () => (dispatch, getState) => {
  return (
    dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.GET_AVAILABLE_DATASETS_REQUEST,
          actionTypes.GET_AVAILABLE_DATASETS_SUCCESS,
          actionTypes.GET_AVAILABLE_DATASETS_FAILURE,
        ],
        endpoint: `/data_sets/available`,
        schema: [dataSetSchema],
        requestMethod: GET,
        payload: {
          expand: 1,
          discoverable_data: true,
        },
      },
    })
      // .then(
      // NSTODO: Stop asking for public Nexsets API times out.
      //   (response) => {
      //     return dispatch(loadPublicDataSets());
      //   },
      //   (error) => {
      //     console.log('error loading public Nexsets');
      //   }
      // )
      .then(
        (response) => {
          dispatch({
            [CALL_PRIVATE_API]: {
              types: [
                actionTypes.GET_AVAILABLE_DATASETS_SUMMARY_REQUEST,
                actionTypes.GET_AVAILABLE_DATASETS_SUMMARY_SUCCESS,
                actionTypes.GET_AVAILABLE_DATASETS_SUMMARY_FAILURE,
              ],
              endpoint: `/data_sets/available`,
              schema: null,
              requestMethod: GET,
              payload: {
                include_summary: 1,
                discoverable_data: true,
              },
            },
          });
        },
        (error) => {
          console.log('Get available Nexsets error');
        },
      )
  );
  // .then(
  //   (response) => {
  //     return dispatch(loadPublicDataSetsSummay());
  //   },
  //   (error) => {
  //     console.log('Error loading Nexsets');
  //   }
  // );
};

export const loadMyAvailableDataSet = (id) => (dispatch, getState) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_AVAILABLE_DATASET_REQUEST,
        actionTypes.GET_AVAILABLE_DATASET_SUCCESS,
        actionTypes.GET_AVAILABLE_DATASET_FAILURE,
      ],
      endpoint: `/data_sets/${id}`,
      schema: dataSetSchema,
      requestMethod: GET,
      payload: {
        expand: 1,
      },
    },
  }).then(
    (response) => {
      dispatch({
        [CALL_PRIVATE_API]: {
          types: [
            actionTypes.GET_AVAILABLE_DATASET_SUMMARY_REQUEST,
            actionTypes.GET_AVAILABLE_DATASET_SUMMARY_SUCCESS,
            actionTypes.GET_AVAILABLE_DATASET_SUMMARY_FAILURE,
          ],
          endpoint: `/data_sets/${id}/summary`,
          schema: null,
          requestMethod: GET,
        },
      });
    },
    (error) => {
      console.log(`Get available Nexset ${id} error`, error);
    },
  );
};
